/* eslint-disable */
// DEPENDENCIES
import React, { Component } from 'react';
import { connect } from 'react-redux';

// INNER IMPORTS
import * as actions from '../../Actions/main';
import { openParticipateModal, closeParticipateModal } from "../../Actions/users";
import { BAND, MUSICIAN } from '../../consts';
import { clientMedia } from '../../Config/Settings'
import { isMobile } from '../../utils';
import { SERVICE } from "../../consts";

// components
import { SelectionSlider } from '../Elements/Carousels';
import {AnalyticsService} from "../../Services";
import { FilterBtns } from "../Elements/Mobile";
import {VideoModal} from "../Modals/Video";

// styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './MapBottomBar.css';

// svgs
import arrowSideSVG from '../inlineSVGs/arrowSideSVG';
import SVGInline from "react-svg-inline";
import {browserHistory} from "react-router";

class MapBottomBar extends Component {
    constructor() {
        super();
        this.state = {
            leftIndex: 0,
            subLeftIndex: 0
        };

        this.subCatScrollerRef = null;
    }

    componentDidMount() {
        this.setState({
            currWidth: window.innerWidth
        });
        window.addEventListener("resize", this.updateWidth.bind(this));
    }
    updateWidth() {
        this.setState({
            currWidth: window.innerWidth
        });
    }

    addCatUriPath(value) {
        if (!value) return window.history.replaceState('', '', `/#${this.props.filters.type}`);

        const urlParams = new URLSearchParams();
        urlParams.append('cat', value)
        // let paramsStr = `?cat=${value}`;
        if (this.props.filters.subCategory) urlParams.append('scat', this.props.filters.subCategory);

        //document.location.href = `${paramsStr}#${this.props.filters.type}`
        window.history.replaceState('', '', `?${urlParams}#${this.props.filters.type}`);
    }

    addSubCatUriPath(value) {
        // if (!value) {
        //     return window.history.replaceState('', '', `/?cat=${this.props.filters.category}#${this.props.filters.type}`);
        // }

        const urlParams = new URLSearchParams();
        if (this.props.filters.category) urlParams.append('cat', this.props.filters.category);

        if (value) urlParams.append('scat', value);

        const qStr = this.props.filters.category || value ? '?' : ''

        window.history.replaceState('', '', `/${qStr}${urlParams.toString()}#${this.props.filters.type}`);
    }

    // this should trigger a refresh as well
    changeCategory(value) {
        if (value === this.props.filters.category) value = null;

        this.props.addFilter('category', value);
        this.props.addFilter('subCategory', '');
        this.addCatUriPath(value)

        // openmic
        // ooo
        let event = AnalyticsService.events.SELECT_FILTER_CAT;

        switch(value) {
            case 'openmic':
                event = AnalyticsService.events.CLICK_CAT_OPEN_STAGE;
                break;
            case 'ooo':
                event = AnalyticsService.events.CLICK_CAT_PLACES_PERFORM;
        }

        AnalyticsService.sendEvent(event, value, null, { value });
    }

    changeSubCategory(value) {
        if (value === this.props.filters.subCategory) value = null;


        this.props.addFilter('subCategory', value);
        this.addSubCatUriPath(value);
    }

    scrollSubCat(side) {
        if (!this.subCatScrollerRef) return;
        if (side === 'left') {
            this.subCatScrollerRef.scrollBy({
                top: 0,
                left: -300,
                behavior: 'smooth'
            });

            return;
        }

        if (side === 'right') {
            this.subCatScrollerRef.scrollBy({
                top: 0,
                left: 300,
                behavior: 'smooth'
            });
        }
    }

    isHideSubCategories() {
        return this.props.filters.type === SERVICE && !this.props.filters.category;
    }

    onVidClick() {
        this.props.closeVideoModal();
        browserHistory.push('/#')
        this.props.openParticipateModal();
    }

    renderMobileFilterBtns() {
        return (
            <FilterBtns
                adType={this.props.filters.type}
                customClass={!this.props.isMobileFilterBar ? 'mobile-filter-btns-mini' : 'mobile-filter-btns-open'}
                handleFilterClick={() => this.props.toggleMobileFilterBar()}
                handleCreateAdClick={() => this.props.isParticipateModalOpen ? this.props.closeParticipateModal() : this.props.openParticipateModal()}
            />
        )
    }

    renderMobileCategories(categoriesSettings, subCategoriesSettings) {
        if (!this.props.isMobileFilterBar) return null;

        return (
            <div className="sliders-wrapper">

                <div
                    className={`close-filter-btn ${this.props.filters.type}`}
                    onClick={() => this.props.toggleMobileFilterBar()}
                >X</div>
                {!this.isHideSubCategories() ?
                    <SelectionSlider
                        scrollAnimDis={-400}
                        sliderType="subCategories"
                        datatypes={this.props.datatypes}
                        filters={this.props.filters}
                        handleClickItem={subCategory => this.changeSubCategory(subCategory)}
                    />
                    : null
                }

                <SelectionSlider
                    scrollAnimDis={400}
                    sliderType="categories"
                    datatypes={this.props.datatypes}
                    filters={this.props.filters}
                    handleClickItem={catName => this.changeCategory(catName)}
                />
            </div>
        )
    }

    renderWebCategories() {
        return (
            <div>
                <div id="categories" className="categories"
                     style={{transform: "translateX(" + this.state.leftIndex + "px)"}}>
                    {this.props.datatypes.categories[this.props.filters.type].map((category, index)=> {
                        if (category.isHidden) return null;

                        return (
                            <div key={index} className={"category "+this.props.filters.type}
                                 onClick={() => this.changeCategory(category.name)}>
                                <div className="icon-wrapper">
                                    <div className={"icon selected"}
                                         style={{
                                             visibility: category.name===this.props.filters.category?"visible":"hidden",
                                             backgroundImage: `url(${clientMedia()}/img/categoriesNeon/${category.name}.svg)`
                                         }}>

                                    </div>
                                    <div className={"icon hover"}
                                         style={{
                                             visibility: category.name===this.props.filters.category?"hidden":"visible",
                                             backgroundImage: `url(${clientMedia()}/img/categoriesHover/${category.name}.svg)`
                                         }}>
                                    </div>
                                    <div className={"icon noHover"}
                                         style={{
                                             visibility: category.name===this.props.filters.category?"hidden":"visible",
                                             backgroundImage: `url(${clientMedia()}/img/categories/${category.name}.svg)`

                                         }}>
                                    </div>
                                </div>
                                <div className="categoryText">
                                    {category.text}
                                </div>
                            </div>
                        )
                    })}
                </div>
                {!(this.props.filters.type === 'service' && !this.props.filters.category)?
                    <div className={`subCategories web ${this.props.filters.type}`}>
                        {this.renderWebSubCategories()}
                    </div> : ""}
            </div>
        )
    }

    renderWebSubCategories () {
        const subCatIndex = this.props.filters.type === 'liveMusic' ? "openmic" : (this.props.filters.category || "musicteachers");

        return (this.props.datatypes.subCategories[subCatIndex] || []).map((subCategory, index) => {
            return (
                <div key={index}
                     className={"subCategory " + (this.props.filters.subCategory === subCategory ? "selected":"unselected")}
                     onClick={()=> {
                         this.changeSubCategory(subCategory)
                     }
                     }>
                    {subCategory}
                </div>
            )
        })
    }

    render() {
        if (!this.props.filters || this.props.filters.type === BAND || this.props.filters.type === MUSICIAN) return null;

        const subCategoriesDecorators = [
            {component: React.createClass({
                render() {
                    return (
                        <div className={`subcategories-left-arrow ${isMobile() ? 'mobile' : ''}`} onClick={this.props.previousSlide}>
                            <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                        </div>
                    )
                }
            })},
            {component: React.createClass({
                render() {
                    return (
                        <div className={`subcategories-right-arrow ${isMobile() ? 'mobile' : ''}`} onClick={this.props.nextSlide}>
                            <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                        </div>
                    )
                }
            }), position: 'CenterRight'}
        ];

        const categoriesDecorators = [
            {component: React.createClass({
                render() {
                    if (isMobile()) return null;

                    return (
                        <div className="categories-left-arrow" onClick={this.props.previousSlide}>&lt;</div>
                    )
                }
            })},
            {component: React.createClass({
                render() {
                    if (isMobile()) return null;

                    return (
                        <div className="categories-right-arrow" onClick={this.props.nextSlide}>&gt;</div>
                    )
                }
            }), position: 'CenterRight'}
        ];

        const subCategoriesSettings = {
            cellSpacing: 1,
            cellAlign: 'left',
            slidesToShow: isMobile() ? 12 : 6,
            slideWidth: isMobile() ? '90px' : '140px',
            speed: 300,
            framePadding: '15px',
            swiping: true,
            dragging: true,
            width: "100%",
            transitionMode: 'scroll',
            scrollMode: 'remainder',
            slidesToScroll: 'auto',// isMobile() ? 2 : 1,
            wrapAround: !isMobile(),
            decorators: subCategoriesDecorators,
        };

        const categoriesSettings = {
            cellSpacing: 10,
            slidesToShow: 6,
            speed: 1000,
            swiping: true,
            width: "100%",
            slidesToScroll: 1,
            wrapAround: false,
            framePadding: "0 25px",
            decorators: categoriesDecorators
        };

        if (!this.props.datatypes) return null;

        // isMobileFilterBar
        return (
            <div className={`mapBottomBar ${!this.props.isMobileFilterBar ? 'mini' : ''} ${this.props.filters.type === SERVICE && !this.props.filters.category ? 'service-no-sub-cat' : ''}`}>
                {isMobile() ? this.renderMobileFilterBtns() : null}
                <div className={`wrapper ${this.props.filters.type === SERVICE && !this.props.filters.category && this.props.isMobileFilterBar ? ' low' : ''}`}>
                    <div className={`title ${this.props.filters.type}`}>
                        קטגוריות
                    </div>
                    {isMobile()
                        ? this.renderMobileCategories(categoriesSettings, subCategoriesSettings)
                        : this.renderWebCategories()
                    }
                </div>

                <VideoModal
                    isModalOpen={this.props.isVideoModalOpen}
                    closeModal={this.props.closeVideoModal}
                    vidUrl={this.props.datatypes.banner.video[this.props.filters.type]}
                    onClick={() => this.onVidClick()}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        datatypes: state.main.datatypes,
        isVideoModalOpen: state.main.isVideoModalOpen,
        filters: state.main.filters,
        isMobileFilterBar: state.main.isMobileFilterBar,
        isParticipateModalOpen: state.users.isParticipateModalOpen,
    };
}
// connecting the component to the actions in order to be able to dispatch them from the component
export const MapBottomBarContainer = connect(mapStateToProps, {
    ...actions,
    openParticipateModal,
    closeParticipateModal,
})(MapBottomBar);

export default MapBottomBar;



// WEBPACK FOOTER //
// ./src/Components/Main/MapBottomBar.js